import { ElementRef, Injectable } from '@angular/core';
import Swal, { SweetAlertIcon } from 'sweetalert2';
@Injectable({
  providedIn: 'root'
})
export class SweetAlertServiceService {

  constructor() { }
  showSwalPopUpMessage(icon?: SweetAlertIcon, title?: any, text?: string, html?: string, showCancelButton?: boolean, cancelButtonText?: string, showConfirmButton?: boolean, confirmButtonText?: string,

    confirmButtonColor?: string, cancelButtonColor?: string, focusConfirm?: boolean, focusCancel?: boolean, reverseButtons?: boolean) {

    Swal.fire({

      icon: icon,

      title: title,

      text: text,

      html: html,

      showCancelButton: (showCancelButton !== null && showCancelButton !== undefined) ? showCancelButton : false,

      cancelButtonText: (cancelButtonText !== null && cancelButtonText !== undefined) ? cancelButtonText : 'Cancel',

      showConfirmButton: (showConfirmButton !== null && showConfirmButton !== undefined) ? showConfirmButton : true,

      confirmButtonText: (confirmButtonText !== null && confirmButtonText !== undefined) ? confirmButtonText : 'OK',

      confirmButtonColor: confirmButtonColor,

      cancelButtonColor: cancelButtonColor,

      focusConfirm: (focusConfirm !== null && focusConfirm !== undefined) ? focusConfirm : true,

      focusCancel: (focusCancel !== null && focusCancel !== undefined) ? focusCancel : false,

      reverseButtons: (reverseButtons !== null && reverseButtons !== undefined) ? reverseButtons : false,

    })

  }

  showSwalToastMessage(icon?: string, title?: any, text?: string, timer?: number, timerProgressBar?: boolean) {

    Swal.fire({

      icon: icon as SweetAlertIcon,

      title: title,

      text: text,

      toast: true,

      position: 'top-end',

      showConfirmButton: false,

      timer: (timer !== null && timer !== undefined) ? timer : 5000,

      timerProgressBar: (timerProgressBar !== null && timerProgressBar !== undefined) ? timerProgressBar : true,

      didOpen: (toast) => {

        toast.addEventListener('mouseenter', Swal.stopTimer)

        toast.addEventListener('mouseleave', Swal.resumeTimer)

      },

    })

  }

  showSwalFocusPopUpMessage(icon?: string, title?: any, text?: string, control?: ElementRef, html?: string, showCancelButton?: boolean, cancelButtonText?: string, showConfirmButton?: boolean, confirmButtonText?: string,

    confirmButtonColor?: string, cancelButtonColor?: string, focusConfirm?: boolean, focusCancel?: boolean, reverseButtons?: boolean) {

    Swal.fire({

      icon: icon as SweetAlertIcon,

      title: title,

      text: text,

      html: html,

      showCancelButton: showCancelButton,

      cancelButtonText: cancelButtonText,

      showConfirmButton: (showConfirmButton !== null && showConfirmButton !== undefined) ? showConfirmButton : true,

      confirmButtonText: (confirmButtonText !== null && confirmButtonText !== undefined) ? confirmButtonText : 'OK',

      confirmButtonColor: confirmButtonColor,

      cancelButtonColor: cancelButtonColor,

      focusConfirm: focusConfirm,

      focusCancel: focusCancel,

      reverseButtons: reverseButtons,

    }).then((result) => {

      if (result.value) {

        if (control !== null && control !== undefined) {

          setTimeout(() => {

            control.nativeElement.focus();

          }, 1000);

        }

      } else if (result.dismiss === Swal.DismissReason.cancel) {

        Swal.fire(

          //TODO

        )

      }

    })

  }

}
